export default __webpack_public_path__ + "static/media/silka-semibold-webfont.d4ef0c3b.eot";